import type { Ref } from 'vue';
import { ref } from 'vue';

// Keyboard-up derived from field focus, not viewport insets: Safari 26 shrinks the layout viewport with the keyboard, making the inset measurement zero.
const isTyping = ref<boolean>(false);

type AiEditorTyping = {
    isTyping: Ref<boolean>;
    setTyping: (typing: boolean) => void;
};

export function useAiEditorTyping(): AiEditorTyping {
    return {
        isTyping,
        setTyping: (typing: boolean): void => {
            isTyping.value = typing;
        },
    };
}

export function resetAiEditorTyping(): void {
    isTyping.value = false;
}
